module.exports = __webpack_public_path__ + "static/media/modicogryllus_frontalis_001_APA.dd362522.png";